import { render, staticRenderFns } from "./MultipleChoiceQuestion.vue?vue&type=template&id=19636a71"
import script from "./MultipleChoiceQuestion.vue?vue&type=script&lang=ts"
export * from "./MultipleChoiceQuestion.vue?vue&type=script&lang=ts"
import style0 from "./MultipleChoiceQuestion.vue?vue&type=style&index=0&id=19636a71&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports